import React, { SVGAttributes } from 'react';

export default function (props: SVGAttributes<SVGElement>) {
    return (
        <svg width="12" height="2" {...props}>
            <path d="M0 1h12" stroke="currentColor" strokeWidth="2" fill="none" fillRule="evenodd" />
        </svg>
    );
}
